<template>
  <div class="common-layout">
    <div class="header">
      <TopNavBar v-if="showTopNavBar" :title="title" />
      <slot name="header"></slot>
    </div>
    <div class="content">
      <slot name="content"></slot>
    </div>
    <div class="footer">
      <BottomNav v-if="showBottomNav" />
      <slot name="footer"></slot>
    </div>
  </div>
</template>
<script setup lang="ts">
import TopNavBar from '@/components/TopNavBar.vue'
import BottomNav from '@/components/BottomNav.vue'
withDefaults(
  defineProps<{
    showBottomNav?: boolean
    showTopNavBar?: boolean
    title?: string
  }>(),
  {
    showBottomNav: true,
    showTopNavBar: false,
    title: '',
  },
)
</script>
<style scoped lang="less">
.common-layout {
  width: 100%;
  height: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  .header {
    flex: 0 0 auto;
  }
  .content {
    flex: 1 1 auto;
    overflow: auto;
    overscroll-behavior: none;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: none;
    -ms-overflow-style: none;
    /* 取消 iOS 顶部/底部回弹（Safari 16+） */
    overscroll-behavior: none;
  }
  .footer {
    flex: 0 0 auto;
  }
}
</style>
